// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","Header":"Header_nYnQC","Nav":"Nav_y97sk"};